import { Link } from "react-router-dom";
import { IMG } from "../../data/site";
import { CASES, ANSWERS } from "../../data/content";
import { Reveal } from "../Motion";
import { Img } from "../Img";
import { Eyebrow, TextLink } from "../Bits";

const STEPS = [
  ["Listen", "What happened, when, and what changed."],
  ["Measure", "Test before replacing anything."],
  ["Explain", "Show the finding in plain language."],
  ["Options", "Repair, replace, or watch, with tradeoffs."],
  ["Verify", "Run it through full cycles before leaving."],
];

export const ProcessSection = () => (
  <section aria-labelledby="proc-h" className="bg-bone2 py-28" data-testid="process-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
      <Reveal className="clip-frame-light order-2 lg:order-1">
        <Img img={IMG.tablet} className="aspect-[4/5] w-full sm:aspect-[4/3] lg:aspect-[4/5]" />
      </Reveal>
      <div className="order-1 lg:order-2">
        <Eyebrow>How a visit works</Eyebrow>
        <h2 id="proc-h" className="h2-display mt-3">The decision stays with you</h2>
        <p className="mt-5 max-w-xl text-slate2">A good furnace visit should leave you understanding your system better than before, whether or not you buy anything.</p>
        <ol className="mt-10 space-y-0">
          {STEPS.map(([t, d], i) => (
            <li key={t} className="border-t border-ink/15">
              <Reveal delay={i * 0.06} className="grid grid-cols-[3.5rem_1fr] items-baseline gap-4 py-5">
                <span className="font-mono text-sm text-flame-deep">0{i + 1}</span>
                <div><h3 className="font-display text-2xl uppercase tracking-tight">{t}</h3><p className="text-slate2">{d}</p></div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export const ProofPreview = () => {
  const c = CASES[1];
  return (
    <section aria-labelledby="proof-h" className="bg-sage-l py-28 text-ink" data-testid="proof-preview">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Eyebrow light>Illustrative work · how proof is structured</Eyebrow>
        <h2 id="proof-h" className="mt-3 max-w-3xl font-display text-5xl uppercase leading-[0.95] tracking-tight sm:text-6xl">{c.title}</h2>
        <div className="mt-14 grid gap-10 lg:grid-cols-2">
          <Reveal className="clip-frame self-start"><Img img={c.img} className="aspect-[4/3] w-full" /></Reveal>
          <ol className="grid gap-px overflow-hidden rounded-2xl bg-line">
            {[["Situation", c.situation], ["Recommendation logic", c.logic], ["Work", c.work], ["Outcome", c.outcome]].map(([k, v], i) => (
              <li key={k} className="bg-ink2 p-6">
                <h3 className="eyebrow text-flame-soft">{i + 1}. {k}</h3>
                <p className="mt-2 text-slate2">{v}</p>
              </li>
            ))}
          </ol>
        </div>
        <div className="mt-10"><TextLink to="/illustrative-work" testid="proof-all-link">See all illustrative work examples</TextLink></div>
      </div>
    </section>
  );
};

export const AnswerPreview = () => {
  const qs = [ANSWERS[1].items[0], ANSWERS[2].items[0], ANSWERS[4].items[0], ANSWERS[0].items[0]];
  return (
    <section aria-labelledby="ans-h" className="bg-bone py-28" data-testid="answer-preview">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <div>
            <Eyebrow>Answer Hub</Eyebrow>
            <h2 id="ans-h" className="h2-display mt-3">Straight answers before you call anyone</h2>
            <div className="mt-8"><TextLink to="/answer-hub" testid="answer-hub-link">Browse every answer by topic</TextLink></div>
          </div>
          <dl className="divide-y divide-ink/15 border-y border-ink/15">
            {qs.map((q) => (
              <div key={q.q} className="py-6">
                <dt className="font-display text-2xl uppercase tracking-tight">{q.q}</dt>
                <dd className="mt-2 text-slate2">{q.a} {q.link && <Link to={q.link} className="link-u font-semibold text-ink">Read more on this topic</Link>}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};
